import styled from 'styled-components';
import { Card, Divider } from '@amzn/storm-ui';

export const AccountSettingsCard = styled(Card)`
  && {
    margin-block-end: ${({ theme }) => theme.spacing.medium.default};
    :last-child {
      margin: 0;
    }
  }
`;

export const AccountSettingsForm = styled.form`
  display: flex;
`;

export const AccountSettingsControllersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small.default};
  max-width: 700px;
  flex: 1 1 auto;
`;

export const AccountSettingsCardContent = styled.div`
  padding: ${({ theme }) => theme.spacing.medium.default};
`;

export const AccountSettingsDivider = styled(Divider)`
  && {
    margin: 0;
  }
`;

export const SellingAccountWrapper = styled.div`
  span:first-child {
    margin-inline-end: ${({ theme }) => theme.spacing.xxsmall.default};
  }
`;
